import { DeliveryMethodEnum, DeliveryTermsEnum, ItemResponsibleEnum, PackaginTrimsEnum, PaymentMethodEnum, PaymentTermsEnum, SalesPersonEnum, StatusEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('sample_co_line')
export class SamplecoLineEntity {

    @PrimaryGeneratedColumn("increment", {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        name: "buyer_po",
        length: 255
    })
    buyerPo: string;

    @Column('varchar', {
        name: "buyer_code",
        length: 255
    })
    buyerCode: string;

    @Column('varchar', {
        name: "buyer_address",
        length: 255
    })
    buyerAddress: string;

    @Column('varchar', {
        name: "delivery_address",
        length: 255
    })
    deliveryAddress: string;

    @Column('varchar', {
        name: "delivery_date",
        length: 255
    })
    deliveryDate: string;
    
    @Column('varchar', {
        name: "item_no",
        length: 255
    })
    itemNo: string;


    @Column("enum", {
        enum: SalesPersonEnum,
        name: 'sales_person',
    })
    salesPerson: SalesPersonEnum;
    

    @Column("enum", {
        enum: ItemResponsibleEnum,
        name: 'item_responsible',
    })
    itemResponsible: ItemResponsibleEnum;


    @Column('varchar', {
        name: "buyer_po_date",
        length: 255
    })
    buyerPoDate: string;


    @Column('varchar', {
        name: "shipment_type",
        length: 255
    })
    shipmentType: string;

    @Column('varchar', {
        name: "agent",
        length: 255
    })
    agent: string;

    @Column('varchar', {
        name: "order_qty",
        length: 255
    })
    orderQty: string;

    @Column('varchar', {
        name: "sales_price",
        length: 255
    })
    salesPrice: string;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;

    @Column("enum", {
        enum: StatusEnum,
        name: 'status',
        default: StatusEnum.OPEN
    })
    status: StatusEnum;

    @Column("varchar", {
        nullable: true,
        name: "error_msg",
    })
    errorMsg: string

    @Column("varchar", {
        nullable: true,
        name: "co_number",
    })
    coNumber: string

    @Column("varchar", {
        nullable: true,
        name: "co_date",
    })
    coDate: string

    @Column('varchar', {
        name: "buyer_style",
        length: 255
    })
    buyerStyle: string;
    
    @Column('varchar', {
        name: "item_description",
    })
    itemDescription: string;

}
